import { Fragment, useEffect, useRef, useState } from "react";

import { Menu, Transition } from "@headlessui/react";
import { appointmentsStatus, views } from "../../../types/calendar";
import CalendarHeader from "../components/CalendarHeader";
import { useSelector } from "react-redux";
import SideBarHours from "../components/dayView/SideBarHours";
import Appointments from "../components/dayView/Appointments";
import { getAppointments } from "../../../network/calendar";
import { useQuery } from "@tanstack/react-query";
import {
  formatDateToYYYYMMDD,
  isDateAndHourInThePast,
  weekEnd,
  weekStart,
} from "../../../utils/DateUtils";
import { message } from "antd";
import { useIntl } from "react-intl";

export default function DayView() {
  const intl = useIntl();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchFilter, setSearchFilter] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState<appointmentsStatus | null>(
    null
  );
  const [dateAndTime, setDateAndTime] = useState<{
    date: Date | null;
    startTime: string | null;
    finishTime: string | null;
  }>({
    date: null,
    startTime: null,
    finishTime: null,
  });
  const { date, view, currentLang, selectedTeamMember, locationId } =
    useSelector(
      (state: {
        calendar: {
          date: Date;
          view: views;
          selectedTeamMember: number | null;
          locationId: number | null;
        };
        user: { currentLang: "en" | "ar" };
      }) => {
        return {
          date: new Date(state.calendar.date),
          view: state.calendar.view,
          currentLang: state.user.currentLang,
          selectedTeamMember: state.calendar.selectedTeamMember,
          locationId: state.calendar.locationId,
        };
      }
    );
  const clickOnDay = ({
    date,
    startTime,
  }: {
    date: Date;
    startTime: string;
  }) => {
    if (isDateAndHourInThePast(date, startTime)) {
      message.error(
        intl.formatMessage({
          id: "pickFutureDate",
          defaultMessage: "يجب تحديد تاريخ مستقبلي",
        })
      );
      return;
    }
    setDateAndTime({
      date: date ? new Date(date) : dateAndTime.date,
      startTime: startTime ? startTime : dateAndTime.startTime,
      finishTime: dateAndTime?.finishTime,
    });
    if (date) {
      setIsModalOpen(true);
    }
  };

  let startDate = "";
  let endDate = "";
  switch (view) {
    case "week":
      startDate = weekStart(date);
      endDate = weekEnd(date);
      break;
    case "day":
      startDate = formatDateToYYYYMMDD(date);
      endDate = startDate;
      break;
    // case "month":
    //   startDate = formatDateToYYYYMMDD(date);
    //   const dateCopy = new Date(date);
    //   dateCopy.setMonth(dateCopy.getMonth() + 1);
    //   endDate = formatDateToYYYYMMDD(dateCopy);

    //   break;
  }
  const params: any = {
    "date_range[from]": startDate,
    "date_range[to]": endDate,
    status: statusFilter,
    client_search: searchFilter,
  };
  if (selectedTeamMember !== null) {
    params["team_member_id"] = selectedTeamMember;
  }
  const { data } = useQuery(
    [
      "appointments",
      date,
      view,
      selectedTeamMember,
      locationId,
      searchFilter,
      statusFilter,
    ],
    () => getAppointments(locationId, params)
  );

  return (
    <div className="flex h-full flex-col">
      <CalendarHeader
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        dateAndTime={dateAndTime}
        setDateAndTime={setDateAndTime}
        setSearchFilter={setSearchFilter}
        setStatusFilter={setStatusFilter}
      />
      <div className="isolate flex flex-auto overflow-hidden bg-white ">
        <div className="flex flex-auto flex-col overflow-auto ">
          {/* responsive mobile view code removed from here */}

          <div className="flex w-full flex-auto ">
            <div className="w-14 flex-none bg-white ring-1 ring-gray-100  " />
            <div className="grid flex-auto grid-cols-1 grid-rows-1 max-h-[800px] ">
              {/* Horizontal lines */}
              <div
                className="col-start-1 col-end-2 row-start-1 grid divide-y divide-gray-100"
                style={{ gridTemplateRows: "repeat(48, minmax(3.5rem, 1fr))" }}
              >
                <div className="row-end-1 h-7"></div>
                <SideBarHours
                  currentLang={currentLang}
                  clickOnDay={clickOnDay}
                  date={date}
                />
              </div>

              {/*  Events */}
              <Appointments appointments={data?.data?.data || []} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
